import * as React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Navigation from '../components/Navigation'
import Footer from '../components/Footer'
import { getLocaleFromPath } from '../utils/i18n'

import './index.css'

export default class TemplateWrapper extends React.Component {
  state = {
    locale: getLocaleFromPath()
  }

  onLocaleChange = locale => {
    this.setState({ locale })
  }

  render() {
    const { data, location, children, ...rest } = this.props
    const { locale } = this.state
    const isHomePage =
      typeof location !== 'undefined' &&
      location.pathname.indexOf(`${locale}/`) === -1

    return (
      <div id="container">
        <Helmet
          title="Augusta Insula"
          meta={[
            {
              name: 'description',
              content:
                'Augusta Insula is the Lastovo island\'s renowned restaurant  and best destination for yacht docking, traditional dining, accommodation and adventure tours.'
            },
            {
              name: 'keywords',
              content:
                'augusta, augusta insula, lastovo, yachting, yacht docking, restaurant, lastovo restaurants, accommodation on lastovo, adventure tours, rental, apartments, rent a car lastovo, lastovo rent a boat'
            }
          ]}
          script={[
            {
              type: 'application/ld+json',
              innerHTML: `{
              "@context": "http://schema.org",
              "@graph": [
                {
                  "@type": "LocalBusiness",
                  "@id": "https://augustainsula.com/",
                  "url": "https://augustainsula.com${location.pathname}",
                  "name": "Augusta Insula",
                  "description": "",
                  "image": "https://augustainsula.com${data.logo.sizes.src}",
                  "telephone": "+385-98-571-884",
                  "priceRange": "$$$",
                  "currenciesAccepted": "HRK",
                  "openingHours": "Mo-Su 09:00-23:00",
                  "paymentAccepted": "Cash, Credit Card",
                  "vatID": "77823200910",
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Zaklopatica 21",
                    "addressLocality": "Lastovo",
                    "addressRegion": "Croatia",
                    "telephone": "+385-98-571-884",
                    "email": "info@augustainsula.com"
                  },
                  "geo": {
                    "@type": "GeoCoordinates",
                    "latitude": 42.7720102,
                    "longitude": 16.8755016
                  }
                },
                {
                  "@context": "http://schema.org",
                  "@type": "Organization",
                  "url": "https://www.augustainsula.com",
                  "logo": "https://augustainsula.com${data.logo.sizes.src}",
                  "sameAs": [
                    "https://www.facebook.com/AugustaInsulaLastovo",
                    "https://www.instagram.com/augusta_insula_lastovo",
                    "https://www.tripadvisor.com/Restaurant_Review-g2039687-d2206293-Reviews-Konoba_Augusta_Insula-Zaklopatica_Lastovo_Island_Dubrovnik_Neretva_County_Dalmat.html"
                  ]
                }
              ]
            }`,
            },
          ]}
        >
          <html lang={locale} />
          <link rel="icon" type="image/png" href={data.logo.sizes.src} />
        </Helmet>
        {isHomePage ? (
          <Header locale={locale} onLocaleChange={this.onLocaleChange} />
        ) : (
          <Navigation
            locale={locale}
            onLocaleChange={this.onLocaleChange}
            logo={data.logo}
          />
        )}
        <div id="page-wrap">
          {children({ ...data, locale, location, ...rest })}
        </div>
        <Footer {...data} locale={locale} logo={data.logo} />
      </div>
    )
  }
}

export const logoImageQuery = graphql`
  query LogoImageQuery {
    logo: imageSharp(id: { regex: "/logo.png/" }) {
      sizes(maxWidth: 145) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js